import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const beverageTypeBaseEndpoint = ENDPOINTS.BEVERAGETYPE;

// Event API using Catering Package endpoints
export const beverageTypeApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["beverageTypes"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getBeverageType: builder.query({
        query: (payload) => `${beverageTypeBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "beverageTypes" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),

      addBeverageType: builder.mutation({
        query: (requestData) => ({
          url: `${beverageTypeBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "beverageTypes" }],
      }),
      updateBeverageType: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${beverageTypeBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "beverageTypes" }],
      }),
      deleteBeverageType: builder.mutation({
        query: (id) => ({
          url: `${beverageTypeBaseEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "beverageTypes" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useAddBeverageTypeMutation,
  useGetBeverageTypeQuery,
  useUpdateBeverageTypeMutation,
  useDeleteBeverageTypeMutation,
} = beverageTypeApi;
